export default {
  // 基础音效
  basic: {
    correct: {
      file: '/static/music/answer_correct.mp3',  // 修改为public目录下的路径
      volume: 0.8,
      preload: true
    },
    wrong: {
      file: '/static/music/answer_error.mp3',
      volume: 0.8,
      preload: true
    },
    click: {
      file: '/static/music/answer_correct.mp3',
      volume: 0.5,
      preload: true
    }
  },

  // 背景音乐
  bgm: {
    main: {
      file: '/static/music/background.mp3',
      volume: 1,
      loop: true,
      preload: true
    },
    battle: {
      file: '/static/music/background.mp3',
      volume: 1,
      loop: true,
      preload: true
    }
  },

  // 特殊音效
  sfx: {
    countdown: {
      file: '/static/music/countdown.mp3',
      volume: 0.6,
      preload: true
    },
    win: {
      file: '/static/music/battle_win.mp3',
      volume: 0.9,
      preload: true
    },
    lose: {
      file: '/static/music/battle_fail.mp3',
      volume: 0.9,
      preload: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/audioConfig.js